const ROUTES = {
  PREFERENCES: "/portal/preferences",
};

export default ROUTES;
